<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Mg_Superv' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView
      [controlClose]="true"
      (onChange)="handleChange($event)"
      (onClose)="closeTab($event)"
      [activeIndex]="index"
      >
      <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
        <div class="table-tools">
          <button
            (click)="add($event)"
            class="p-button p-component p-button-text-only btn-square"
            >
            {{'Add_Superv' | translate}}
          </button>
        </div>
        <br class="col-12 md:col-12" />
        <p-table
          #dt
          [selectionMode]="'single'"
          [columns]="listColumns"
          [value]="dataList"
          [rows]="100"
          [paginator]="true"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          (onRowSelect)="showDetails($event)"
          (onFilter)="setFilteredList($event)"
          [sortField]="'name'"
          >
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ dataList.length }} {{'Superv_1' | translate}}</span>
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th [pSortableColumn]="columns[0].field" class="width-auto">
                <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{ columns[0].header }}
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                  style="color: darkgrey"
                  />
                </th>
                <th [pSortableColumn]="columns[1].field" class="width-auto">
                  <p-sortIcon [field]="columns[1].field"></p-sortIcon>{{ columns[1].header }}
                  <input
                    (click)="$event.stopPropagation()"
                    pInputText
                    type="text"
                    (input)="dt.filter($event.target.value, columns[1].field, 'contains')"
                    style="color: darkgrey"
                    />
                  </th>
                </tr>
              </ng-template>
              <ng-template let-rowData let-columns="columns" pTemplate="body">
                <tr [pSelectableRow]="rowData">
                  <td class="width-auto">
                    {{ rowData[columns[0].field] }}
                  </td>
                  <td class="width-auto">
                    {{ rowData[columns[1].field] }}
                  </td>
                </tr>
              </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">{{'Empty' | translate}}</td>
            </tr>
          </ng-template>
            </p-table>
          </p-tabPanel>
          @for (item of itemsSelected; track item; let i = $index) {
            <p-tabPanel
              header="{{ item._label }}"
              [selected]="i == index - 1"
              [closable]="true"
              >
              @if (item.id === -1) {
                <app-add-supervbase
                  [groupList]="groupList"
                  [userList]="userList"
                  [basketList]="basketList"    
                  (onCancel)="cancelAdd($event)"
                  (onValidate)="addTab($event)"
                  >
                </app-add-supervbase>
              }
              @if (item.id !== -1) {
                <app-edit-supervbase
                  [item]="item"
                  [groupList]="groupList"
                  [userList]="userList"
                  [basketList]="basketList"    
                  (onCancel)="closeTab($event)"
                  (onValidate)="validateTab($event)"
                  (onDeleteItem)="confirmDelete($event)"
                  >
                </app-edit-supervbase>
              }
            </p-tabPanel>
          }
        </p-tabView>
      </div>
    </div>

    <app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
